import React, { useContext, useEffect, useState } from "react";
import CondimentsList from "../../components/Condiment/CondimentList";
import Box from "../../UI/Box";
import Filter from "../../components/Filter/Filter";
import { VIEW_TYPE, SORTING_TYPE } from "../../entities/Filter";
import { useSelector } from "react-redux";
import { getSelectedCondiments } from "../../components/Condiment/selectors";
import { getDataFromMixture } from "../../components/Mixture/selectors";
import { useAppDispatch } from "../../store/store";
import { resetMixtureState } from "../../components/Mixture/MixtureSlice";
import { onOpenModal } from "../../components/Modal/slice/ModalSlice";
import { MODAL_TYPES } from "../../entities/Modal";
import { getValueForKey } from "../../context/translationsUtils";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import { clearSelectedCondiments } from "../../components/Condiment/CondimentSlice";
import { resetCalculationState } from "../../components/Calculation/slice/CalculationSlice";

const Custom: React.FC = () => {
  const [sort, setSort] = useState<SORTING_TYPE>(SORTING_TYPE.ASC);
  const [view, setView] = useState<VIEW_TYPE>(VIEW_TYPE.GRID);
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const [disableSelected, setDisableSelected] = useState<boolean>(true);
  const selectedCondiments = useSelector(getSelectedCondiments);
  const { condimentLimitPerMix } = useSelector(getDataFromMixture);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (selectedCondiments.length >= condimentLimitPerMix) {
      setDisableSelected(false);
      dispatch(
        onOpenModal({
          modalType: MODAL_TYPES.ALERT,
          content: {
            name: getValueForKey(translations, "alerts.alert_title", {}, true),
            description: `${getValueForKey(
              translations,
              "alerts.condiment_limit_reached",
              {},
              true,
            )} ${condimentLimitPerMix}`,
          },
        }),
      );
    } else {
      setDisableSelected(true);
    }
  }, [condimentLimitPerMix, selectedCondiments.length, dispatch, translations]);

  useEffect(() => {
    dispatch(clearSelectedCondiments());
    dispatch(resetCalculationState());
    dispatch(resetMixtureState());
  }, [dispatch]);

  return (
    <Box>
      <Filter sort={sort} view={view} setSort={setSort} setView={setView} />
      <CondimentsList
        sort={sort}
        view={view}
        disableSelected={disableSelected}
      />
    </Box>
  );
};

export default Custom;
